import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme/theme.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { PubNubAngular } from 'pubnub-angular2';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TokenInterceptor } from './interceptor/app-token-interceptor';
import { ScriptLoaderService } from './_services/script-loader.service';
import { ThemeRoutingModule } from './theme/theme-routing.module';
import { MainRoutingModule } from './portalV2/main-routing.module';
import { AuthModule } from './auth/auth.module';
import { WINDOW_PROVIDERS } from './_services/window.service';
import { DashboardService } from './_services/main/dashboard.service';
import { AuthService } from './_services/main/auth.service';
import { NegotiatorService } from './_services/main/negotiator.service';
import { CsrService } from './_services/main/csr.service';
import { PortalV2Service } from './_services/main/portalv2.service';
import { ElectricityService } from './_services/main/electricity.service';
import { PlanService } from './_services/main/plan.service';
import { AnalyticsService } from './_services/common/analytics.service';
import { AppLoadingService } from './_services/common/loading.service';
import { ValidationService } from './_services/common/validation.service';
import { SharedService } from './_services/common/shared.service';
import { AlertService } from './_services/common/alert.service';
import { ReportsService } from './_services/main/reports.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Ng5SliderModule } from 'ng5-slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// import { SimplePdfViewerModule } from '../assets/vendors/custom/simple-pdf-viewer';
import { MainModule } from './portalV2/main.module';
import { ComparatorService } from './_services/main/comparator.service';
import { ScraperService } from './_services/main/scraper.service';
import { AuthGuard } from './auth/_guards/auth.guard';
import { BoardsService } from './_services/main/boards.service';
import { NotificationsService } from './_services/main/notifications.service';
import { QaService } from './_services/main/qa.service';
// import { NgxChartsModule } from '@swimlane/ngx-charts';

import { ToastrModule } from 'ngx-toastr';
import { SavingsEstimateComponent } from './savings-estimate/savings-estimate.component';
import { PubNubService } from './_services/main/pubnub.service';
import { PubNubAngular } from 'pubnub-angular2';
@NgModule({
  declarations: [ThemeComponent, AppComponent, SavingsEstimateComponent],
  imports: [
    LayoutModule,
    BrowserModule,
    MainModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ThemeRoutingModule,
    MainRoutingModule,
    AuthModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    // SimplePdfViewerModule
    ToastrModule.forRoot(),
    Ng5SliderModule,
    NgbModule.forRoot()
    // NgxChartsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    ScriptLoaderService,
    // PubNubAngular,
    AnalyticsService,
    ValidationService,
    AlertService,
    DashboardService,
    ComparatorService,
    ScraperService,
    AppLoadingService,
    NegotiatorService,
    CsrService,
    PortalV2Service,
    ElectricityService,
    PlanService,
    AuthService,
    SharedService,
    WINDOW_PROVIDERS,
    AuthGuard,
    BoardsService,
    NotificationsService,
    QaService,
    ReportsService,
    PubNubService,
    PubNubAngular
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts